import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { EnvService } from '@src/app/modules/env';
import { UserService } from '@src/core/services';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'reports',
  templateUrl: './reports.component.html',
  styleUrls: ['../styles/administration-content.scss', './reports.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsComponent extends BaseResizableComponent {
  private readonly userService = inject(UserService);
  private readonly env = inject(EnvService);
  private readonly translateService = inject(TranslateService);

  reports = [
    {
      id: 1,
      title: this.translateService.instant('components.reports.labels.activeUsersTitle'),
      description: this.translateService.instant('components.reports.labels.activeUsersDescription'),
      action: () => this.getActiveUsersReport(),
    },
  ];

  private async getActiveUsersReport(): Promise<void> {
    this.userService
      .getActiveUsers(undefined, undefined, this.env.isBot)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(response => {
        this.env.downloadFileByHttpResponse(response);
      });
  }
}
